import { useSelection } from "@/app/department-context"
import { OrganizationGroupListPage } from "../organization-group/organization-group-list-page"
import { NoOrganizationSelected } from "@/component/no-organization-selected"

export const OrganizationGroupsPage = () => {
  const { currentOrganization: organization } = useSelection()
  if (!organization) {
    return <NoOrganizationSelected />
  }
  return <OrganizationGroupListPage organizationId={organization.id} />
}
